var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.657 12.038l-1.418-1.411-3.255 3.27L6.971.292l-2 .002.013 13.568-3.23-3.215-1.41 1.417 5.67 5.644 5.643-5.67z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxMiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjY1NjggMTIuMDM3OEwxMC4yMzkzIDEwLjYyNjlMNi45ODQzNCAxMy44OTcyTDYuOTcwNjUgMC4yOTIxMTRMNC45NzA2NSAwLjI5NDEyN0w0Ljk4NDMxIDEzLjg2MTlMMS43NTQwOCAxMC42NDY3TDAuMzQzMTc1IDEyLjA2NDNMNi4wMTMyMyAxNy43MDc5TDExLjY1NjggMTIuMDM3OFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };